import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { BackofficeUserListDesktopLayout } from './layouts/desktop';
import { BackofficeUserListMobileLayout } from './layouts/mobile';

export function BackofficeUserListLayout() {
  const { isMobileOrTablet } = useDeviceBreakpoints();

  return (
    <>
      {isMobileOrTablet ? (
        <BackofficeUserListMobileLayout />
      ) : (
        <BackofficeUserListDesktopLayout />
      )}
    </>
  );
}
